import {Box, Skeleton} from '@mui/material';

import {departmentHealthSectionCardSx} from './departmentHealthSectionStyles';
import {EmpionPaper} from '../../../../../components/EmpionPaper/EmpionPaper';

export const DepartmentHealthDataFreshnessSkeleton = () => (
  <EmpionPaper sx={departmentHealthSectionCardSx}>
    <Box sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 1.75}}>
      <Box sx={{flex: 1}}>
        <Box sx={{display: 'flex', alignItems: 'center', gap: 0.75, mb: 0.5}}>
          <Skeleton variant='circular' width={15} height={15} />
          <Skeleton variant='text' width={120} height={18} />
        </Box>
        <Skeleton variant='text' width='75%' height={14} />
      </Box>
      <Skeleton variant='rounded' width={110} height={24} sx={{borderRadius: '99px', flexShrink: 0}} />
    </Box>
    <Skeleton variant='rounded' width='100%' height={11} sx={{borderRadius: '99px', mb: 1.25}} />
    <Box sx={{display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 1, mb: 1.75}}>
      {Array.from({length: 4}).map((_, index) => (
        <Skeleton key={index} variant='rounded' height={72} sx={{borderRadius: '9px'}} />
      ))}
    </Box>
    <Skeleton variant='rounded' width='100%' height={52} sx={{borderRadius: '8px'}} />
  </EmpionPaper>
);
